import { Button, Input, Row, Select, Tag } from "antd";
import styled from "styled-components";
import { PRIMARY_THEME, SECONDARY_THEME } from "../../constants/constant";

export const StyledInput = styled(Input)`
  padding: 12px;
  background: ${(props) => (props.background ? props.background : " #fcfcfc")};
  width: ${(props) => (props.width ? props.width : "390px")};
  &::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus-within {
    border-color: ${PRIMARY_THEME};
  }
  &:hover {
    border-color: ${PRIMARY_THEME};
  }
`;

export const StyledPasswordInput = styled(Input.Password)`
  padding: 12px;
  background: ${(props) => (props.background ? props.background : " #fcfcfc")};
  width: ${(props) => (props.width ? props.width : "390px")};
`;
export const FullHeightRow = styled(Row)`
  height: 100vh;
  &.space-around {
    justify-content: space-around;
  }
  &.login-page {
    background: #fcfcfc;
    align-items: center;
  }
`;
export const StyledSelect = styled(Select)`
  .ant-select-selector {
    padding: 12px !important;
    height: 48px !important;
    border-radius: 6px !important;
    background: ${(props) =>
      props.background ? props.background : " #fcfcfc"} !important;
    width: ${(props) => (props.width ? props.width : "390px")} !important;
  }
  .ant-select-arrow {
    margin-top: 0;
  }
  .ant-select-selector:focus-within {
    border-color: ${PRIMARY_THEME} !important;
  }
  .ant-select-selector:hover {
    border-color: ${PRIMARY_THEME} !important ;
  }
`;
export const StyledButton = styled(Button)`
  &.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
    color: white;
    background: ${SECONDARY_THEME};
    border-color: ${SECONDARY_THEME};
  }
  display: ${(props) => props.display};
  background: ${(props) => (props.background ? props.background : " #292929")};
  padding: 8px 32px 8px 32px;
  width: ${(props) => props.width};
  height: ${(props) => (props.height ? props.height : "42px")};
  border-radius: 8px;
  border: ${(props) => (props.border ? props.border : " 1px solid #292929")};
  box-sizing: border-box;
  color: ${(props) => (props.color ? props.color : "white")};
  font-weight: 700;
  &:hover,
  :focus {
    background: ${(props) =>
      props.hoverBackground ? props.hoverBackground : props.background};
    color: ${(props) => (props.color ? props.color : "white")};
    border: ${(props) =>
      props.border ? props.border : `1px solid ${PRIMARY_THEME}`};
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.27);
  }
`;

export const StyledLink = styled.a`
  color: ${PRIMARY_THEME};
`;

export const salesOrderStatus = (value) => {
  return (
    <Tag
      className="flex items-center justify-center"
      color={
        value === "Placed"
          ? "blue"
          : value === "Pending"
          ? "warning"
          : value === "Preparing"
          ? "orange"
          : value === "Shipped"
          ? "gold"
          : value === "Delivered"
          ? "success"
          : "error"
      }
    >
      {value}
    </Tag>
  );
};
